import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PDComponent from '../../pd-component'

const LinkGrid = ({
    regions = [],
    dividerColor = 'black',
    backgroundColor = 'transparent',
    textAlignment = 'center'
}) => {
    return (
        <Box
            display={{base: 'grid', md: 'none'}}
            backgroundColor={backgroundColor}
            gridTemplateColumns="repeat(2, 1fr)"
            gap="0"
            padding="10px 0px 10px 0px"
            sx={{
                '& > .button-link': {
                    position: 'relative',
                    padding: '15px 0',
                    width: '100%',
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '15px',
                        height: '1px',
                        backgroundColor: dividerColor
                    }
                },
                // Remove bottom padding and divider for last two items
                '& > .button-link:last-child, & > .button-link:nth-last-child(2)': {
                    paddingBottom: '15px',
                    marginBottom: 0,
                    '&::after': {
                        content: 'none'
                    }
                },
                // Typography styles for headings and paragraphs
                'h1, h2, h3, h4, h5, h6, p': {
                    fontSize: '20px',
                    fontWeight: 400,
                    letterSpacing: '0.1px',
                    margin: '0px 15px 0px 15px !important',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    textAlign: textAlignment,
                    overflow: 'hidden'
                }
            }}
        >
            {regions.map((region) =>
                region.components?.map((component, index) => (
                    <PDComponent key={`${region.id}-${index}`} component={component} />
                ))
            )}
        </Box>
    )
}

LinkGrid.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            components: PropTypes.arrayOf(PropTypes.object)
        })
    ).isRequired,
    dividerColor: PropTypes.string,
    textAlignment: PropTypes.string,
    backgroundColor: PropTypes.string
}

export default LinkGrid
